import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "estimatedCost" }
const _hoisted_5 = { style: {"color":"#EB4545"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("p", null, "확인 부탁 드립니다!")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tip" }, " 해당 주문하신 상품 수가 200건 초과되었습니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "tip" }, " 비즈니스 회원으로 변경하시면 수수료가 무료입니다(입고수수료&출고수수료). "),
  /*#__PURE__*/_createElementVNode("p", { class: "tip" }, " 비즈니스 회원으로 업그레이드 해 드릴까요? ")
], -1)
const _hoisted_8 = { class: "dialog-footer" }

import { ref, computed } from 'vue'
import { isJA, useRtfix, isKO } from '@/store'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: ['totalBuyQuantity', 'closeExceeding'],
  emits: ['closeExceeding'],
  setup(__props, { expose, emit: emits }) {

const props = __props


const dialogVisible = ref(false)

// 入库手续费
const warehousingPrice = computed(() => {
  return Number(props.totalBuyQuantity) * 1
})
// 出库手续费
const outboundPrice = computed(() => {
  return Number(props.totalBuyQuantity) * 1
})

const open = () => {
  dialogVisible.value = true
}
const closeModal = () => {
  dialogVisible.value = false
  emits('closeExceeding')
}
expose({
  open
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    width: "480px",
    "custom-class": "exceedingNumTip",
    "close-on-click-modal": false,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_el_button, { onClick: closeModal }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('暂不升级')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: _unref(useRtfix)('VipLevel')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              style: {"margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('去升级')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    default: _withCtx(() => [
      (_unref(isJA)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('温馨提示')), 1)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", {
                class: "tip",
                innerHTML: _unref(t)('当前提交的订单商品数量达X件，升级标准舱预计本单可节省Y元手续费(入库手续费&出库手续费)，是否升级后再下单？')
          .replace('X', __props.totalBuyQuantity).replace('Y', `${_unref(warehousingPrice) + _unref(outboundPrice)}` )
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('入库手续费(预估)')) + "：1元/" + _toDisplayString(_unref(t)('件1')) + " * " + _toDisplayString(__props.totalBuyQuantity) + _toDisplayString(_unref(t)('件1')) + " = " + _toDisplayString(_unref(warehousingPrice)) + "元", 1),
                _createElementVNode("p", null, _toDisplayString(_unref(t)('出库手续费(预估)')) + "：1元/" + _toDisplayString(_unref(t)('件1')) + " * " + _toDisplayString(__props.totalBuyQuantity) + _toDisplayString(_unref(t)('件1')) + " = " + _toDisplayString(_unref(outboundPrice)) + "元", 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('可节省手续费合计(预估)').replace('X', `${_unref(warehousingPrice) + _unref(outboundPrice)}`)), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isKO)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_6,
            _hoisted_7
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})